import React from "react";

import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

interface Props {}

const GoToDashboard: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <Link to={Path.DASHBOARD}>
      <Button key="return" type="primary">
        {intl.formatMessage({
          id: "settings.newImports.finalizeStep.returnButton",
          defaultMessage: "Go to Dashboard",
          description: "Text of return button",
        })}
      </Button>
    </Link>
  );
};

export default GoToDashboard;
